import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Careers from './pages/Careers';
import Dashboard from './pages/Dashboard';
import ServicePage from './pages/ServicePage';
import Contact from './pages/Contact';
import AllServices from './pages/AllServices';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import NotFound from './pages/NotFound';
import './App.css';

const loaderStyles = `
@keyframes loader-bar {
  0%   { width: 0%; }
  30%  { width: 45%; }
  60%  { width: 72%; }
  85%  { width: 88%; }
  100% { width: 100%; }
}
@keyframes loader-dot {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.3; }
  40%            { transform: scale(1);   opacity: 1; }
}
@keyframes loader-fade-out {
  0%   { opacity: 1; visibility: visible; }
  100% { opacity: 0; visibility: hidden; }
}
.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #020617;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}
.loader-overlay.exiting {
  animation: loader-fade-out 0.5s ease forwards;
}
.loader-logo {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  background: linear-gradient(135deg, #60a5fa 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.loader-logo span {
  -webkit-text-fill-color: #60a5fa;
  color: #60a5fa;
}
.loader-bar-track {
  width: 180px;
  height: 2px;
  background: rgba(255,255,255,0.06);
  border-radius: 9999px;
  overflow: hidden;
}
.loader-bar-fill {
  height: 100%;
  border-radius: 9999px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
  animation: loader-bar 1.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}
.loader-dots {
  display: flex;
  gap: 6px;
}
.loader-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3b82f6;
  animation: loader-dot 1.2s ease-in-out infinite;
}
.loader-dot:nth-child(2) { animation-delay: 0.15s; background: #6366f1; }
.loader-dot:nth-child(3) { animation-delay: 0.3s;  background: #8b5cf6; }
`;

function PageLoader({ onDone }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const exit = setTimeout(() => setExiting(true), 1600);
    const done = setTimeout(() => onDone(), 2100);
    return () => { clearTimeout(exit); clearTimeout(done); };
  }, [onDone]);

  return (
    <>
      <style>{loaderStyles}</style>
      <div className={`loader-overlay${exiting ? ' exiting' : ''}`}>
        <div className="loader-logo">
          Cod<span>inity</span>
        </div>
        <div className="loader-bar-track">
          <div className="loader-bar-fill" />
        </div>
        <div className="loader-dots">
          <div className="loader-dot" />
          <div className="loader-dot" />
          <div className="loader-dot" />
        </div>
      </div>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <PageLoader onDone={() => setLoading(false)} />}
      <Router>
        <Routes>
          <Route element={<Dashboard />}>
            <Route path="/" element={<Home embedded />} />
            <Route path="/careers" element={<Careers embedded />} />
            <Route path="/services" element={<AllServices />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
